import { FC } from 'react'
import { IntegrationsModule } from 'components/pages/Workspace/Integrations'
import { PageContent } from 'components/common/Page/PageContent'

export const WorkspaceIntegrationsContent: FC = () => {
  return (
    <PageContent>
      <IntegrationsModule />
    </PageContent>
  )
}
